import { apiGet } from "../baseApi";
import { setDomainUserData } from "service/mapper";

// Rejected login attempts of the district's 911 dispatcher domains
export const getRejectedUserList = async ({ params, config = {} }) => {
  const response = await apiGet("_domainUserRejected", params, null, config);
  return {
    ...response,
    rowData: (Array.isArray(response.data?.users) ? response.data.users : []).map((el) =>
      setDomainUserData(el),
    ),
  };
};
